import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy, Loader2, Search } from "lucide-react";
import { AnnouncePanel } from "./AnnouncePanel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CustomerEmails = ({ auth }) => {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    axios.get(`${API}/admin/customers`, auth()).then((r) => setList(r.data)).catch(() => setList([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (list === null) return <Loader2 className="w-6 h-6 animate-spin text-[#0B1F3A]" />;
  const term = q.trim().toLowerCase();
  const shown = list.filter((c) => !term || `${c.email} ${c.name} ${c.phone}`.toLowerCase().includes(term));

  const copyAll = async () => {
    await navigator.clipboard.writeText(shown.map((c) => c.email).join(", "));
    toast.success(`${shown.length} email copiate`);
  };

  return (
    <section data-testid="customer-emails">
      <AnnouncePanel auth={auth} />
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <p data-testid="customer-emails-count" className="text-xs uppercase tracking-[0.2em] text-[#6F6466] mr-auto">Email clienti · {list.length}</p>
        <label className="flex items-center gap-2 rounded-full border border-[rgba(11,31,58,0.2)] bg-white px-4 py-2">
          <Search className="w-4 h-4 text-[#6F6466]" />
          <input data-testid="customer-emails-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca" className="bg-transparent outline-none text-sm w-40" />
        </label>
        <button data-testid="customer-emails-copy" onClick={copyAll} disabled={!shown.length} className="inline-flex items-center gap-2 rounded-full bg-[#0B1F3A] text-white px-4 py-2 text-xs font-bold uppercase tracking-wider hover:bg-[#071528] disabled:opacity-40 transition-colors">
          <Copy className="w-4 h-4" /> Copia email
        </button>
      </div>
      <div className="rounded-2xl border border-[rgba(11,31,58,0.15)] bg-white overflow-x-auto">
        <table data-testid="customer-emails-table" className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-[0.15em] text-[#6F6466]">
            <tr><th className="px-5 py-3">Email</th><th className="px-5 py-3">Nome</th><th className="px-5 py-3">Telefono</th><th className="px-5 py-3">Prenotazioni</th><th className="px-5 py-3">Tessera</th></tr>
          </thead>
          <tbody className="divide-y divide-[rgba(26,20,22,0.06)]">
            {shown.map((c) => (
              <tr key={c.email} data-testid={`customer-row-${c.email}`}>
                <td className="px-5 py-3 font-medium min-w-[220px] break-words">{c.email}</td>
                <td className="px-5 py-3">{c.name || "—"}</td>
                <td className="px-5 py-3 whitespace-nowrap">{c.phone || "—"}</td>
                <td className="px-5 py-3">{c.bookings}{c.last_booking ? ` · ult. ${c.last_booking}` : ""}</td>
                <td className="px-5 py-3 font-mono-alt text-xs whitespace-nowrap">{c.card_code ? `${c.card_code} · ${c.card_stamps}/10` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {shown.length === 0 && <p className="p-5 text-sm text-[#6F6466]">Nessuna email.</p>}
      </div>
    </section>
  );
};
